<template>
  <section class="how-we-work">
    <h2 class="title">How We Work</h2>

    <div class="steps">

      <div class="step">
        <div class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2v6h6M8 13h8M8 17h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h3>Instant Quote</h3>
        <p>
          Send us 2D & 3D design files, then get free DFM feedback and quotes in a few hours.
        </p>
      </div>

      <div class="step">
        <div class="icon">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m9.25 18.876l-6.512-4.682m3.002-2.673l5.143 3.813M.751 11.751a2.5 2.5 0 1 0 5 0a2.5 2.5 0 0 0-5 0m4.886-.746l5.611-5.465m-.856-3.962L1.257 10.25m8.492-7a2.5 2.5 0 1 0 5 0a2.5 2.5 0 0 0-5 0m6.545 4.132l-2.3-2.35m1.756 3.719a2 2 0 1 0 4 0a2 2 0 0 0-4 0"/><path d="M19.7 8.3a3 3 0 0 1 3.55 2.951m-3 3A3 3 0 0 1 17.3 10.7M1 23.251h22m-13.75 0V18a3 3 0 0 1 6 0v5.25"/></g></svg>
        </div>
        <h3>Production</h3>
        <p>
          Once the quote and order are confirmed, production starts in a few hours.
        </p>
      </div>

      <div class="step">
        <div class="icon">
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.56 3.91c.59.59.59 1.54 0 2.12l-3.89 3.89l2.12 9.19l-1.41 1.42l-3.88-7.43L9.6 17l.36 2.47l-1.07 1.06l-1.76-3.18l-3.19-1.77L5 14.5l2.5.37L11.37 11L3.94 7.09l1.42-1.41l9.19 2.12l3.89-3.89c.56-.58 1.56-.58 2.12 0"/></svg>
        </div>
        <h3>Delivery & Receive</h3>
        <p>
          After passing quality inspections, the parts are carefully packed and ready for shipment.
        </p>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'HowWeWork'
}
</script>

<style scoped>
.how-we-work {
  padding: 90px 20px;
  text-align: center;
  background: #fff;
}

.title {
  font-size: 34px;
  font-weight: 600;
  margin-bottom: 44px;
  color: #111;
}

.steps {
  display: flex;
  justify-content: center;
  gap: 70px;
  /* 去除了 flex-wrap: wrap，强制在大于等于 1024px 时在一行显示 3 列 */
}

.step {
  /* 允许均分宽度并限制最大宽度 */
  flex: 1;
  max-width: 300px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}

.icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 18px;
  color: #111;
  transition: all 0.3s ease;
}

.icon svg {
  width: 100%;
  height: 100%;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.step h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #111;
  transition: all 0.3s ease;
}

.step p {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
}

/* 小于 1024px 时单列排版 */
@media (max-width: 1023px) {
  .steps {
    flex-direction: column;
    align-items: center;
    gap: 45px;
  }
}
</style>